import styled from 'styled-components';

import ArrowRightIcon from 'assets/icons/arrows/arrow-right-16.svg';

export const ArrowRight = styled(ArrowRightIcon)`
    margin-left: auto;
    min-width: 1.6rem;
`;
